import { render, staticRenderFns } from "./EvaluationsSummaryTable.vue?vue&type=template&id=491abfdf&scoped=true&"
import script from "./EvaluationsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationsSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationsSummaryTable.vue?vue&type=style&index=0&id=491abfdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491abfdf",
  null
  
)

export default component.exports